import { sample } from 'effector';
import { signout } from '@features/common';
import { ChannelInstance } from '@features/socket-chats-reworked/types/common';
import { leaveChannel } from '../channels/channels.model';
import { changeMessageInput } from '../chat-input/chat-input.model';
import { $currentChatId } from '../chat/chat.model';
import { sendMessage } from '../messages/messages.model';
import { persistSession } from '../root/root.model';
import { $drafts, draftChanged, draftRemoved } from './drafts.model';

persistSession({ store: $drafts, key: 'drafts' });

/** При вводе текста сообщения обновляем черновик текущего чата */
sample({
  clock: changeMessageInput,
  source: $currentChatId,
  filter: (channelId) => Boolean(channelId),
  fn: (channelId, text) => ({ channelId: channelId as ChannelInstance['id'], text }),
  target: draftChanged,
});

/** После отправки сообщения удаляем черновик этого чата */
sample({
  clock: sendMessage,
  fn: ({ channel_key }) => channel_key,
  target: draftRemoved,
});

/** При выходе из канала удаляем его черновик */
sample({
  clock: leaveChannel,
  target: draftRemoved,
});

$drafts
  .on(draftChanged, (drafts, { channelId, text }) => {
    if (!text) {
      if (!(channelId in drafts)) return drafts;

      const next = { ...drafts };

      delete next[channelId];

      return next;
    }

    return { ...drafts, [channelId]: text };
  })
  .on(draftRemoved, (drafts, channelId) => {
    if (!(channelId in drafts)) return drafts;

    const next = { ...drafts };

    delete next[channelId];

    return next;
  })
  .reset(signout);
